import { render, staticRenderFns } from "./pcourseintroduce.vue?vue&type=template&id=0d455a08&scoped=true&"
import script from "./pcourseintroduce.vue?vue&type=script&lang=js&"
export * from "./pcourseintroduce.vue?vue&type=script&lang=js&"
import style0 from "./pcourseintroduce.vue?vue&type=style&index=0&id=0d455a08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d455a08",
  null
  
)

export default component.exports